import type { NetworkPayload } from "../../../composites";
import type { PreferredLanguagePayload } from "./types";

const URL = "me/language_preference";

export const API = {
  setPreferredLanguage: (
    payload: PreferredLanguagePayload,
  ): NetworkPayload<PreferredLanguagePayload> => {
    return {
      url: URL,
      options: {
        payload,
        method: "PATCH",
        isJsonResponse: true,
      },
    };
  },
};
